import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import useExchangePortalAxios from "../../utils/axios";
import { resetResponseState } from "../../features/responseSlice";
import { clearNotifications } from "../../features/webSocketSlice";
import { clearWebSocketState } from "../store/slices/appSlice";

export default function useNewLogoutAPI() {
  const navigate = useNavigate();
  const client = useExchangePortalAxios();
  const dispatch = useDispatch();
  const isLoggingOut = useRef(false);

  const logout = async () => {
    if (isLoggingOut.current) return;
    isLoggingOut.current = true;

    await client
      .post("/v1/Auth/LogOut", {
        SessionID: sessionStorage.getItem("SessionID"),
      })
      .finally(() => {
        sessionStorage.clear();
        dispatch(resetResponseState());
        dispatch(clearNotifications());
        dispatch(clearWebSocketState());
        navigate("/", { replace: true });
      });
  };

  return { logout };
}
